<template>
  <div id="content-wrapper">
    <div class="container-fluid pb-0">
      <div class="top-mobile-search">
        <div class="row">
          <div class="col-md-12">
            <form class="mobile-search">
              <div class="input-group">
                <input type="text" placeholder="Search for..." class="form-control" />
                <div class="input-group-append">
                  <button type="button" class="btn btn-dark">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
              </div>
              <h6 style>
                <span v-if="is_debug===true">
                  <strong style="color:red">THIS IS FOR DEBUG</strong>
                </span>
                Showing results for "{{
                $route.params.keywords
                }}"
              </h6>
            </div>
          </div>
          <div
            class="col-md-12 text-center"
            v-if="found_nothing"
            style="margin-top: 20vh;margin-bottom: 20vh;"
          >
            <h2>No results found.</h2>
            <h5>Try different keywords</h5>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="(video, i) in videoinfos" v-bind:key="i">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="parseInt(video.duration)"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
            <!-- TODO: duration 返回api类型正常以后去掉 v-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import videoinfocard from "../components/videoinfocard.vue";
import BasicAPIs from "../api/apis";
export default {
  name: "PgSearchResults",
  components: {
    videoinfocard
  },
  props: {},
  data: function() {
    return {
      videoinfos: [],
      found_nothing: false,
      research_res: {}
    };
  },
  computed: {
    is_debug() {
      return this.$store.state.debug;
    }
  },
  created() {
    let vm = this;
    let kw = this.$route.params.keywords;
    console.log(kw);
    if (this.$store.state.debug) {
      this.found_nothing = true;
    } else {
      BasicAPIs.getSearchResults(kw).then(res => {
        if (res.data.success) {
          // this.research_res = res.data;
          if (res.data.data.Count > 0) {
            console.log(res.data);
            vm.videoinfos = res.data.data.Items;
            vm.found_nothing = false;
          } else {
            vm.found_nothing = true;
          }
        } else {
          alert("search api error");
        }
      });
    }

    // Action
  },
  mounted() {
    console.log("mount search");
  }
};
</script>


<style  lang='scss'>
</style>